module.exports = __webpack_public_path__ + "static/media/10.eb915940.jpg";